import { displayRealEstateType } from '../../RealEstateProperty';
import { decayedLimit, isDecayed } from '../../util';
import { AmountSumTableItem, AmountSumTableItemProps } from './Table';
import { latestDataPointGroupUpdateDate, latestDataPointGroupUpdateDateTime } from '../../DataPointGroup';
import { useTranslation } from 'react-i18next';
import { RealEstate } from '../../generated/graphql';

export interface RealEstateSumTableItemProps
  extends Pick<
    AmountSumTableItemProps,
    'amount' | 'subtitle' | 'decayed' | 'dataTestID' | 'withChevron' | 'className' | 'motionProps' | 'contentPrefix'
  > {
  realEstate: RealEstate;
  itemTitle?: string;
  onItemClicked?: (a: { realEstate: RealEstate }) => void;
}

export const RealEstateSumTableItem = ({ realEstate, onItemClicked, ...props }: RealEstateSumTableItemProps) => {
  const { t: tRealEstate } = useTranslation('realEstate');

  return (
    <AmountSumTableItem
      contentPrefix={props.contentPrefix}
      motionProps={props.motionProps}
      dataTestID={realEstate.name}
      title={props.itemTitle ?? realEstate.name}
      amount={props.amount ?? realEstate.ownedValue}
      onClick={() => onItemClicked?.({ realEstate })}
      withChevron={props.withChevron ?? !!onItemClicked}
      lastUpdated={latestDataPointGroupUpdateDateTime(realEstate.value)}
      onKeyDown={(e) => e.key === 'Enter' && onItemClicked?.({ realEstate })}
      subtitle={props.subtitle ?? displayRealEstateType(tRealEstate, realEstate.realEstateType)}
      decayed={isDecayed(latestDataPointGroupUpdateDate(realEstate.value), decayedLimit.RealEstate)}
      {...props}
    />
  );
};
